module.exports = __webpack_public_path__ + "img/pink_cloud_top.89d22103.svg";